export default "__VITE_ASSET__BsPchOlx__"